import ChangeOrderOfAlbumsBtn from './ChangeOrderOfAlbumsBtn';
export default ChangeOrderOfAlbumsBtn;